import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import type { FranchiseType } from '../types';
import { apiClient } from '@/_config/lib/axios/api-client';

export interface PlaceFareDataParams extends Omit<FranchiseType, '_id'> {}

interface PostCreatePlaceFareParams {
  placeId: string;
  fareData: PlaceFareDataParams;
}

const postCreatePlaceFare = async ({
  placeId,
  fareData,
}: PostCreatePlaceFareParams) =>
  apiClient
    .post(`/estabelecimentos/${placeId}/fare/create-fare`, fareData)
    .then(response =>
      handleResponseSuccess(
        response,
        'Tarifa do estabelecimento criada com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível criar a tarifa do estabelecimento.',
      ),
    );

export const useCreatePlaceFare = () => {
  return useMutation({
    mutationFn: postCreatePlaceFare,
  });
};
